
import React from 'react';

interface ComplianceScoreDisplayProps {
  complianceScore: number;
  complianceColor: string;
  complianceStatus: string;
}

const ComplianceScoreDisplay = ({ 
  complianceScore, 
  complianceColor, 
  complianceStatus 
}: ComplianceScoreDisplayProps) => {
  return (
    <div className="relative flex-1 flex items-center justify-center mb-6">
      <div className="text-center">
        <div className="relative inline-flex items-center justify-center">
          <svg className="w-36 h-36">
            <circle 
              className="text-gray-700" 
              strokeWidth="6" 
              stroke="currentColor" 
              fill="transparent" 
              r="60" 
              cx="70" 
              cy="70" 
            />
            <circle 
              className={complianceColor} 
              strokeWidth="6" 
              strokeDasharray={`${complianceScore * 3.77}, 400`} 
              strokeLinecap="round" 
              stroke="currentColor" 
              fill="transparent" 
              r="60" 
              cx="70" 
              cy="70" 
              style={{ transform: 'rotate(-90deg)', transformOrigin: 'center' }} 
            />
          </svg>
          <span className="absolute text-3xl font-bold text-white">{complianceScore}%</span>
        </div>
        <div className={`mt-2 font-medium ${complianceColor}`}>
          {complianceStatus}
        </div>
      </div>
    </div>
  );
};

export default ComplianceScoreDisplay;
